export const API_HOST = "https://cmsapi.fantuan.ca"
export const MERCHANT = "https://merchant.fantuanorder.com"
